import { useForm } from "../../provider/Form/FormProvider";
import React, { useState } from "react";
import { formValue } from "../../services/formServiceFunctions";
import ValidatorSelectField, { ValidatorSelectFieldProps } from "./ValidatorSelectField";
import { FormDataTypes } from "../../types/FormDataTypes";
import MenuItem from "@mui/material/MenuItem";
import { Checkbox, IconButton, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

type ValidatorMultiSelectFieldWithCheckboxesProps = Omit<ValidatorSelectFieldProps<string[]>, "multiple" | "children"> & {
  options: Array<{ value: string; label: string }>;
};
export default function ValidatorMultiSelectFieldWithCheckboxes({ options, name, ...rest }: ValidatorMultiSelectFieldWithCheckboxesProps) {
  const { values }: FormDataTypes = useForm();
  const [openSelect, setOpenSelect] = useState(false);

  return (
    <ValidatorSelectField
      name={name}
      multiple
      {...rest}
      open={openSelect}
      onOpen={() => setOpenSelect(true)}
      onClose={() => setOpenSelect(false)}
      renderValue={(selected: string[]) => {
        return selected.map((value) => options.find((option) => option.value === value)?.label).join(", ");
      }}
    >
      <Stack
        direction="row"
        onClick={() => setOpenSelect(false)}
        sx={{
          justifyContent: "flex-end",
          marginRight: "15px"
        }}>
        <IconButton size="small" aria-label="Close select menu">
          <CloseIcon />
        </IconButton>
      </Stack>
      {options.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          <Checkbox checked={formValue(values, name).includes(option.value)} />
          <Typography sx={{ whiteSpace: "normal" }}>{option.label}</Typography>
        </MenuItem>
      ))}
    </ValidatorSelectField>
  );
}
